<template>
  <div class="wrap">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/css/reset.css";
@import "@/assets/css/fonts.css";
@import "@/assets/css/common.css";
@import "@/assets/css/default.css";
</style>